import { render, staticRenderFns } from "./companyNews.vue?vue&type=template&id=f2e00698&scoped=true&"
import script from "./companyNews.vue?vue&type=script&lang=js&"
export * from "./companyNews.vue?vue&type=script&lang=js&"
import style0 from "./companyNews.vue?vue&type=style&index=0&id=f2e00698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e00698",
  null
  
)

export default component.exports